import React from 'react';
import { useMEMTranslation } from '../utils/text-utils';
import { MessageBar, PageTitle } from '../providers/harmony-scope/lazy-enablers';
import { bodyContentStyles, titleCommandBarStyles } from '../utils/common-styles';

export const UnknownUser = () => {
  const { t } = useMEMTranslation();
  return (
    <div style={bodyContentStyles}>
      <div style={titleCommandBarStyles}>
        <PageTitle>{t('appTitle')}</PageTitle>
      </div>
      <MessageBar open noCloseButton appearance="warning" style={{ margin: '1rem' }}>
        {t('sellerExperienceUnknownUserError')}
      </MessageBar>
    </div>
  );
};
